import { createStore } from "vuex";
import Product from '@/models/product'
import User from "@/models/user";
import Order from "@/models/order";
import btn from '@/models/popup_button';
import { Packaging } from "@/models/packaging";
import Point from "@/models/point";
import { ProductWithPackaging } from "@/models/product";

const storedCart = localStorage.getItem("cart");
const storedUser = localStorage.getItem("user");
const storedPoints = localStorage.getItem("points");
const selectedPoint = localStorage.getItem("selectedPoint");
const lastOpenShop = localStorage.getItem("last_open_shop");

// Тип для корзины с разделением по точкам
interface PointCart {
  [pointId: number]: ProductWithPackaging[];
}

interface popUp {
  open: boolean, 
  text: string | null, 
  buttons: btn[] | null
}

export default createStore({
  state: {
    user: (storedUser && storedUser.startsWith("{")) ? JSON.parse(storedUser) : {
      id: 0,
      telegram_id: "",
      username: "",
      photo_url: "",
      role: "",
    },
    points: storedPoints ? JSON.parse(storedPoints) as Point[] : [],
    selectedPoint: selectedPoint ? JSON.parse(selectedPoint) as Point : null,
    cart: storedCart ? JSON.parse(storedCart) as PointCart : {},
    products: [] as Product[],
    orders: [] as Order[],
    admins: [],
    telegramretrieveLaunchParams: null as any | null,
    authToken: null as string | null,
    popUp: {} as popUp,
    last_open_shop: lastOpenShop ? lastOpenShop as string : null
  },
  getters: {
    getLastOpenShop: state => {
      return state.last_open_shop;
    },

    getSelectedPoint: state => {
      return state.selectedPoint;
    },
    getAllPoints: state => {
      return state.points;
    },
    getStatusPopUp: state => {
      return state.popUp;
    },
    // Получить все товары из корзины (всех точек)
    getAllCartItems: state => {
      return Object.values(state.cart).flat();
    },
    
    // Получить корзину для конкретной точки
    getCartItemsByPoint: (state) => (pointId: number) => {
      return state.cart[pointId] || [];
    },

    getAllProducts: (state) => state.products,
    
    // Получить структуру корзины с группировкой по точкам
    getCartByPoints: state => {
      return Object.entries(state.cart).map(([pointId, items]) => ({
        pointId: Number(pointId),
        items
      }));
    },
    
    // Получить конкретный товар из корзины точки
    getProductFromPoint: (state) => (pointId: number, productId: number) => {
      const pointItems = state.cart[pointId];
      if (!pointItems) return null;
      return pointItems.find(item => item.id === productId);
    },
    
    // // Получить общее количество товаров во всех точках
    // getTotalItemsCount: state => {
    //   return Object.values(state.cart).reduce((total, items) => {
    //     return total + items.reduce((sum, item) => sum + (item.quantity || 1), 0);
    //   }, 0);
    // },
    
    // Старые геттеры (оставляем для обратной совместимости)
    getOrders: (state) => state.orders,
    getAdmin: (state) => state.admins,
    USER: (state) => { 
      return state.user
    },
    TELEGRAM_RETRIENE_LAUNCH_PARAMS: state => state.telegramretrieveLaunchParams,
    AUTH_TOKEN: state => state.authToken,
  },
  mutations: {
    SET_LAST_OPEN_SHOP(state, date: string) {
      state.last_open_shop = date;
    },
    SET_SELECTED_POINT(state, point: Point) {
      state.selectedPoint = point;
    },
    SET_ALL_POINTS_INFO(state, points: Point[]) {
      state.points = points;
    },
    SET_POPUP_PARAMS(state, popUp: popUp) {
      state.popUp = popUp;
    },
    SET_AUTH_TOKEN(state, token: string) {
      state.authToken = token;
    },
    SET_TELEGRAM_RETRIENE_LAUNCH_PARAMS(state, payload: any) { 
      state.telegramretrieveLaunchParams = payload;
    }, 
    SET_USER: (state, payload: User) => {
      if (typeof payload !== "object" || payload === null) {
        console.error("SET_USER: Некорректный payload", payload);
        return;
      }
    
      state.user = payload;
      localStorage.setItem("user", JSON.stringify(payload));
    },
    
    // Добавить товар в корзину точки
    addToPointCart(state, { pointId, product }: { pointId: number; product: ProductWithPackaging }) {
      // Инициализируем корзину для точки, если её нет
      if (!state.cart[pointId]) {
        state.cart[pointId] = [];
      }
      
      const existingProduct = state.cart[pointId].find((item: ProductWithPackaging) => (item.id === product.id) && (item.packaging.id === product.packaging.id));
      if (existingProduct) {
        existingProduct.quantity = (existingProduct.quantity || 1) + (product.quantity || 1);
      } else {
        // Добавляем новый товар
        state.cart[pointId].push({
          ...product,
          quantity: product.quantity || 1
        });
      }
      
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },
    
    // Удалить товар из корзины точки
    removeFromPointCart(state, { pointId, productId, packaging }: { pointId: number; productId: number, packaging: Packaging }) {
      if (!state.cart[pointId]) return;
      
      state.cart[pointId] = state.cart[pointId].filter((item) => !(item.id === productId && item.packaging.id === packaging.id));
      
      // Если после удаления товаров в точке не осталось, удаляем запись точки
      if (state.cart[pointId].length === 0) {
        delete state.cart[pointId];
      }
      
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },
    
    // Обновить количество товара в корзине точки
    updatePointCartQuantity(state, { pointId, id, quantity, packaging }: { pointId: number; id: number; quantity: number, packaging: Packaging }) {
      if (!state.cart[pointId]) return;
      
      const product = state.cart[pointId].find(item => (item.id === id) && (item.packaging.id === packaging.id));
      if (product) {
        product.quantity = quantity;
      }
      
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },

    // Переместить корзину из одной точки в другую
    // moveCartToPoint(state, { fromPointId, toPointId, merge }: { fromPointId: number; toPointId: number; merge: boolean }) {
    //   if (!state.cart[fromPointId]) {
    //     console.warn(`Корзина для точки ${fromPointId} не найдена`);
    //     return;
    //   }
      
    //   // Если целевая точка существует и merge = true, объединяем корзины
    //   if (state.cart[toPointId] && merge) {
    //     // Объединяем товары с учетом одинаковых товаров (по id и packaging)
    //     const targetItems = state.cart[toPointId];
    //     const sourceItems = state.cart[fromPointId];
        
    //     // Для каждого товара из исходной корзины ищем такой же товар в целевой корзине
    //     // Если товар уже есть, увеличиваем количество
    //     // Если товара нет, добавляем его
    //     sourceItems.forEach(sourceItem => {
    //       const existingItem = targetItems.find(
    //         item => item.id === sourceItem.id && item.packaging.id === sourceItem.packaging.id
    //       );
    //       if (existingItem) {
    //         existingItem.quantity = (existingItem.quantity || 1) + (sourceItem.quantity || 1);
    //       } else {
    //         targetItems.push({ ...sourceItem });
    //       }
    //     });
    //   } else {
    //     // Если целевой точки нет или merge = false, просто копируем корзину
    //     state.cart[toPointId] = [...state.cart[fromPointId]];
    //   }

    //   delete state.cart[fromPointId];
    //   localStorage.setItem("cart", JSON.stringify(state.cart));
    // },
    
    // Очистить корзину конкретной точки
    clearPointCart(state, pointId: number) {
      delete state.cart[pointId];
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },
    
    // Очистить все корзины (всех точек)
    clearAllCarts(state) {
      state.cart = {};
      localStorage.removeItem("cart");
    },

    setProducts(state, products: Product[]) {
      state.products = products
    },

    clearProducts(state) {
      state.products = [];
    }
  },
  actions: {
    setLastOpenshop({commit}, date: string) {
      commit('SET_LAST_OPEN_SHOP', date)
    },

    moveCartToPoint({ commit }, { fromPointId, toPointId, merge }: { fromPointId: number; toPointId: number; merge: boolean }) {
      commit("moveCartToPoint", { fromPointId, toPointId, merge });
    },
    
    setSelectedPoint({commit}, point:Point) {
      commit("SET_SELECTED_POINT", point)
    },

    setAllPoints({commit}, points: Point[]) {
      commit("SET_ALL_POINTS_INFO", points);
    },

    setPopUp({commit}, popUp: popUp) {
      commit("SET_POPUP_PARAMS", popUp);
    },

    setAuthToken({ commit }, token: string) {
      commit("SET_AUTH_TOKEN", token);
    },
    
    setTelegramRetrieveLaunchParams({ commit }, payload) {
      commit("SET_TELEGRAM_RETRIENE_LAUNCH_PARAMS", payload);
    },
    
    setUser({commit}, user: User) {
      commit("SET_USER", user);
    },
    
    addProductToCart({ commit }, { product, pointId }: { product: ProductWithPackaging; pointId: number }) {
      commit("addToPointCart", { pointId, product });
    },
    
    removeProductFromCart({ commit }, { productId, pointId, packaging }: { productId: number; pointId: number, packaging: Packaging }) {
      commit("removeFromPointCart", { pointId, productId, packaging });
    },
    
    updateProductQuantity({ commit }, { id, quantity, pointId, packaging }: { id: number; quantity: number; pointId: number; packaging: Packaging }) {
      commit("updatePointCartQuantity", { pointId, id, quantity, packaging });
    },
    
    clearPointCart({ commit }, pointId: number) {
      commit("clearPointCart", pointId);
    },
    
    clearAllCart({ commit }) {
      commit("clearAllCarts");
    },
    
    setProducts({ commit }, products: Product[]) {
      commit("setProducts", products)
    },

    clearProducts({ commit }) {
      commit("clearProducts")
    },

  },
});